module.exports = __webpack_public_path__ + "images/2af9fd51163843f23e1b3171c514fbf9.png";